export enum moduleType {
    homeowner = 1,
    mobilehome = 4,
    renter = 2,
    condo = 3
}
